import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import ListPoktanPage from '@/components/pages/guest/_list-poktan/containers/list-poktan-page'
import { useFilters } from '@/components/pages/guest/_list-poktan/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_list-poktan/types'

export const Route = createFileRoute('/_guest/guest/list-poktan')({
  component: RouteComponent,
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const filters = useFilters()

  useEffect(() => {
    filters.onPoktanStatusChange(
      search.poktan_status as 'active' | 'inactive' | undefined,
      false
    )
    filters.onStatusChange(search.status, false)
    if (search.poktan_class_id) {
      filters.onPoktanClassChange(search.poktan_class_id, false)
    }
    if (search.poktan_usaha_id) {
      filters.onPoktanUsahaChange(search.poktan_usaha_id, false)
    }
    if (search.poktan_type_id) {
      filters.onPoktanTypeChange(search.poktan_type_id, false)
    }
    if (search.poktan_program_id) {
      filters.onPoktanProgramChange(search.poktan_program_id, false)
    }
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    if (search.district_code) {
      filters.onDistrictChange(search.district_code, false)
    }
    if (search.village_code) {
      filters.onVillageChange(search.village_code, false)
    }
    if (search.search) {
      filters.onSearchChange(search.search, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search.poktan_status,
    search.status,
    search.province_code,
    search.city_code,
    search.district_code,
    search.village_code,
    search.poktan_class_id,
    search.poktan_usaha_id,
    search.poktan_type_id,
    search.poktan_program_id,
    search.search
  ])

  return <ListPoktanPage />
}
